export const isServicesSelected = servicesSelected => {
  return !!Object.values(servicesSelected).find(service => service.length > 0);
};
export const filterBySelectedServices = financialServicesSelected => {
  return Object.entries(financialServicesSelected).reduce((acc, [key, value]) => {
    return value.length ? Object.assign({}, acc, {
      [key]: value
    }) : acc;
  }, {});
};
export const selectedServicesId = selected => {
  return Object.values(selected).reduce((acc, curr) => acc.concat(curr), []);
};